<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Clientes', 'link' : '/client' }]"
    />

    <h1 class="text-center" v-if="operation === 'store'">Cadastrar Cliente</h1>
    <h1 class="text-center" v-if="operation === 'update'">Atualizar Cliente</h1>
    <!-- Div Formulario -->
    <form class="row" v-if="!loading" @submit.prevent="actionOperation" @keydown.enter.prevent>
      <div class="col-2"></div>
      <div class="col-12 col-md-8" >
        <div class="row">
          <div class="col-12">
            <div class="form-check text-center">
              <label class="form-label me-2">Tipo:</label>
              <input value="PF" class="btn-check" type="radio" autocomplete="off" checked v-model="clientmodel.type" name="clientType" id="radioPF">
              <label class="btn btn-outline-primary me-2" for="radioPF">PF</label>
              <input value="PJ" class="btn-check" type="radio" autocomplete="off" v-model="clientmodel.type" name="clientType" id="radioPJ">
              <label class="btn btn-outline-success" for="radioPJ">PJ</label>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-md col-sm-12">
              <div class="form-group">
                <label v-if="clientmodel.type == 'PF'" for="newClientName">Nome:</label>
                <label v-else for="newClientName">Nome fantasia:</label>
                <input required v-model="clientmodel.name" name="newClientName" type="text" class="form-control" id="newClientName" placeholder="">
              </div>
            </div>
            <div v-if="clientmodel.type == 'PJ'" class="col col-md-6">
              <div class="form-group">
                <label for="newClientLegalName">Razão social:</label>
                <input v-model="clientmodel.name_legal" type="text" class="form-control" id="newClientLegalName" name="newClientLegalName" placeholder="">
              </div>
            </div>
          </div>
          <div v-if="clientmodel.type == 'PF'" class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientCPF">CPF:</label>
              <input v-model="clientmodel.cpf_cnpj" type="text" class="form-control" id="newClientCPF" name="newClientCPF" placeholder="" />
            </div>
          </div>
          <div v-if="clientmodel.type == 'PJ'" class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientCNPJ">CNPJ:</label>
              <input v-model="clientmodel.cpf_cnpj" type="text" class="form-control" id="newClientCNPJ" name="newClientCNPJ" placeholder="" />
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-12 col-md-6 mt-3">
              <div class="form-group">
                <label for="newClientEMAIL">E-mail:</label>
                <input v-model="clientmodel.email" type="text" class="form-control" id="newClientEMAIL" name="newClientEMAIL" placeholder="">
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <div class="form-group">
                <label for="newClientWhatsapp">Whatsapp:</label>
                <input v-model="clientmodel.phone" type="text" class="form-control" id="newClientWhatsapp" name="newClientWhatsapp" placeholder="" />
              </div>
            </div>
          </div>
          <div v-if="clientmodel.type == 'PJ'" class="row m-0 p-0">
            <div class="col-md col-sm-12 mt-3">
              <div class="form-group">
                <label for="newClientNameRespo">Nome do Responsável:</label>
                <input v-model="clientmodel.responsible_name" type="text" class="form-control" id="newClientNameRespo" name="newClientNameRespo" placeholder="">
              </div>
            </div>
            <div class="col-md col-sm-12 mt-3">
              <div class="form-group">
                <label for="newClientWhatsRespo">Whatsapp do Responsável:</label>
                <MaskInput mask="(##) #####-####" v-model="clientmodel.responsible_phone" type="text" class="form-control" id="newClientWhatsRespo" name="newClientWhatsRespo" placeholder=""/>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientDate">Data de Aniversário:</label>
              <input v-model="clientmodel.birthdate_incorporation" type="date" class="form-control" id="newClientDate" name="newClientDate" placeholder="">
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientEndereco">Endereço:</label>
              <input v-model="clientmodel.address" type="text" class="form-control" id="newClientEndereco" name="newClientEndereco" placeholder="">
            </div>
          </div>
          <div class="row m-0 p-0 mt-3">
            <div class="col-md col-sm-12">
              <div class="form-group">
                <label for="newClientCidade">Cidade:</label>
                <input v-model="clientmodel.city" type="text" class="form-control" id="newClientCidade" name="newClientCidade" placeholder="">
              </div>
            </div>
            <div class="col-md col-sm-12 form-group">
              <label for="inpTxtRentalState">Estado:</label>
              <select v-model="clientmodel.state" required class="form-control" name="inpTxtRentalState" id="inpTxtRentalState">
                <!-- Default disabled option for instruction -->
                <option value="" disabled selected>Selecione o Estado</option>
                <!-- Iterate over the states list -->
                <option v-for="state in stateslist" :value="state.uf" :key="state.uf">
                  {{ state.name }}
                </option>
              </select>
            </div>
            <div class="col-md col-sm-12">
              <div class="form-group">
                <label for="newClientCEP">CEP:</label>
                <input v-model="clientmodel.zipcode" type="text" class="form-control" id="newClientCEP" name="newClientCEP" placeholder=""/>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientObs">Observação:</label>
              <textarea v-model="clientmodel.note" type="text" class="form-control" id="newClientObs" name="newClientObs" placeholder=""></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2"></div>
      <!-- Div Botão Salvar -->
      <div class="row mt-4 text-center">
        <div class="col-12">
          <router-link class="btn btn-secondary me-2" to="/client">
            Voltar
          </router-link>
          <button @click="actionOperation" class="btn btn-primary me-2">
            <span>{{ operation === 'store' ? 'Salvar' : 'Atualizar' }}</span>
          </button>
          <button @click="clearForm" class="btn btn-secondary me-2">
            Limpar
          </button>
        </div>
      </div>
      <div style="height: 90px;"></div>
    </form>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3 text-center">
      <div>
        <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" v-if="operation === 'update' && loading">Carregando dados do cliente...</p>
        <p class="mt-2" v-else-if="loading">Salvando cliente...</p>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive, ref } from 'vue';
import { clientes } from '@/models/clientes';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import states from '@/services/states.js';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import router from '@/router';

export default {
  name: "NewClientView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const toastStore = useToastStore();
    var loading = ref(false);
    var operation = ref('store');
    const model = clientes();
    const getstates = states.get();
    const stateslist = getstates;

    const clientmodel = reactive({
      type: 'PF',
      name : null,
      name_legal : null,
      email : null,
      cpf_cnpj : null,
      phone : null,
      responsible_phone : null,
      responsible_name : null,
      birthdate_incorporation : null,
      address : null,
      city : null,
      state : null,
      zipcode : null,
      note : null
    });

    onMounted(() => {
      const query = window.location.search;
      const urlParams = new URLSearchParams(query);
      const edit = urlParams.get('edit');
      const id = urlParams.get('id');

      if (edit && id) {
        document.title = "Atualizar Cliente - AlugaSoft";

        operation.value = 'update';
        loading.value = true;
        model.getOne(id).then((response) => {
          clientmodel.id = response.id;
          clientmodel.type = response.type;
          clientmodel.name = response.name;
          clientmodel.name_legal = response.name_legal;
          clientmodel.email = response.email;
          clientmodel.cpf_cnpj = response.cpf_cnpj;
          clientmodel.phone = response.phone;
          clientmodel.responsible_phone = response.responsible_phone;
          clientmodel.responsible_name = response.responsible_name;
          clientmodel.birthdate_incorporation = response.birthdate_incorporation;
          clientmodel.address = response.address;
          clientmodel.city = response.city;
          clientmodel.state = response.state;
          clientmodel.zipcode = response.zipcode;
          clientmodel.note = response.note;
          loading.value = false;
        }).catch((error) => {
          toastStore.error('Erro ao carregar cliente: ' + parseError(error));
          loading.value = false;
        });
      }
    });

    const actionOperation = () => {
      if (operation.value === 'update') {
        update();
      } else {
        if (!clientmodel.name) {
          toastStore.warning('O nome é obrigatório.');
          return;
        }
        store();
      }
    }

    function store() {
      loading.value = true;
      model.store(clientmodel).then(() => {
        toastStore.success('Cliente cadastrado com sucesso!');
        loading.value = false;
        router.push('/client');
      }).catch((error) => {
        loading.value = false;
        toastStore.error('Erro ao cadastrar cliente: ' + parseError(error));
      });
    }

    function update() {
      loading.value = true;
      model.update(clientmodel).then(() => {
        toastStore.success('Cliente atualizado com sucesso!');
        loading.value = false;
        router.push('/client');
      }).catch((error) => {
        toastStore.error('Erro ao atualizar cliente: ' + parseError(error));
        loading.value = false;
      });
    }

    return {
      stateslist,
      clientmodel,
      actionOperation,
      operation,
      loading
    }

  }
}
</script>